export function hasInteractiveRights(catalogEntity: $TSFixMe): boolean {
  return catalogEntity && catalogEntity.getIn(['rightsInfo', 'hasInteractive'], false);
}

export function isUnavailable(catalogEntity: $TSFixMe): boolean {
  return (
    catalogEntity &&
    !hasInteractiveRights(catalogEntity) &&
    !catalogEntity.getIn(['rightsInfo', 'hasRadioRights'], true)
  );
}

export function isRadioOnly(catalogEntity: $TSFixMe): boolean {
  return (
    catalogEntity &&
    !hasInteractiveRights(catalogEntity) &&
    catalogEntity.getIn(['rightsInfo', 'hasRadioRights'], false)
  );
}

export function hasNoRadio(catalogEntity: $TSFixMe): boolean {
  return catalogEntity && !catalogEntity.get('hasRadio');
}

export function isRetired(catalogEntity: $TSFixMe): boolean {
  return catalogEntity && catalogEntity.get('contentState') === 'RETIRED';
}

export function isRemoved(catalogEntity: $TSFixMe): boolean {
  return catalogEntity && catalogEntity.get('contentState') === 'REMOVED';
}
